import React from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import ExternalFeePaymentPage from "./feePayment";
import StudentSelection from "./studentSelection";
import { isMobileDevice } from "../../helpers/Utils";
import { onPaymentFailure } from "../../actions";
import moment from "moment";

const IS_MOBILE = isMobileDevice();

class ExternalFeeCollection extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedPaymentDate: moment(),
    };
    this.paymentFailure = this.paymentFailure.bind(this);
  }

  componentDidMount() {}

  renderHeader() {
    return (
      <div
        style={{
          boxShadow: "0 3px 6px 0 rgba(0, 0, 0, 0.08)",
          backgroundColor: "white",
          height: 65,
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          position: "fixed",
          width: "100%",
          zIndex: 4,
          top: 0,
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            paddingLeft: IS_MOBILE ? 20 : 50,
          }}
        >
          <div
            style={{
              fontWeight: 800,
              backgroundColor: IS_MOBILE && "#f7f7f7",
              padding: 5,
              borderRadius: 4,
              cursor: "pointer",
            }}
            onClick={() => {
              window.location.href = `/`;
            }}
          >
            <span style={{ fontSize: 24 }}>
              <span style={{ color: "rgb(255,95,95)" }}>
                {IS_MOBILE ? "F" : "FEE"}
              </span>
              <span style={{ color: "rgb(69,69,69)" }}>
                {IS_MOBILE ? "B" : "BOARD"}
              </span>
            </span>
          </div>
        </div>
        <div style={{ display: "flex", alignItems: "center" }}>
          {IS_MOBILE ? (
            <div style={{ marginRight: 20, fontSize: 35 }}>
              <a href="tel:08047187111">
                <i className="fa fa-phone" style={{ color: "#152a53" }}></i>
              </a>
            </div>
          ) : (
            <div
              style={{
                color: "rgb(69,69,69)",
                fontSize: 18,
                marginRight: IS_MOBILE ? 20 : 40,
              }}
            >
              080-471-87111
            </div>
          )}
        </div>
      </div>
    );
  }

  paymentFailure(res) {
    const { selectedPaymentDate } = this.state;
    const { student_id } = this.props.match.params;
    this.props.onPaymentFailure(res, student_id, selectedPaymentDate)
  }

  render() {
    const { student_id } = this.props.match.params;
    const { selectedPaymentDate } = this.state;
    return (
      <div>
        {this.renderHeader()}
        {student_id ? (
          <ExternalFeePaymentPage key={`${student_id}_${selectedPaymentDate}`}
            studentId={student_id} selectedPaymentDate={selectedPaymentDate}
            onPaymentFailure={this.paymentFailure}
            updateSelectedDate={(date) => {
              this.setState({
                selectedPaymentDate: moment(date),
              })
            }
            }
          />
        ) : (
          <StudentSelection />
        )}
      </div>
    );
  }
}

const mapStateToProps = () => ({
  
});

export default withRouter(
  connect(mapStateToProps, {
    onPaymentFailure,
  })(ExternalFeeCollection)
);
